import { Card, CardBody, CardHeader } from "reactstrap";
import { faSortAlphaDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OrderByButton } from "../OrderByButton";
import { Column } from "../Column";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

interface Props<E> {
  columns: Column<E>[];
  changeOrderBy: (newField: keyof E) => void;
  currentOrder: "asc" | "desc";
  currentField: keyof E;
}

export function OrderingCard<E>({
  columns,
  changeOrderBy,
  currentOrder,
  currentField,
}: Props<E>) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <FontAwesomeIcon icon={faSortAlphaDown} /> {t("common.sorting")}
      </CardHeader>
      <CardBody>
        {columns.map((c, i) => (
          <Fragment key={i}>
            <OrderByButton<E>
              title={c.title}
              field={c.field}
              changeOrderBy={changeOrderBy}
              currentField={currentField}
              currentOrder={currentOrder}
              renderBullet={true}
            />
            <br />
          </Fragment>
        ))}
      </CardBody>
    </Card>
  );
}
